import { useSceneStore } from "@/state/useSceneStore";
import type { HotspotAction } from "@/types";
import { track } from "@/lib/analytics";
import { cameraTargets } from "@/scene/cameras/cameraTargets";

const assertNever = (x: never): never => {
  throw new Error(`unhandled hotspot action: ${String(x)}`);
};

export const runHotspotAction = (action: HotspotAction): void => {
  const s = useSceneStore.getState();
  switch (action) {
    case "toggleBook": {
      const opening = s.activeSection !== "about";
      s.setActiveSection(opening ? "about" : null);
      const isMobile =
        typeof window !== "undefined" &&
        window.matchMedia("(max-width: 992px)").matches;
      const targetPose = opening
        ? isMobile
          ? cameraTargets.mobileShots.about
          : cameraTargets.about
        : isMobile
          ? cameraTargets.mobileShots.hero
          : cameraTargets.default;
      s.requestCameraMove(targetPose, 1.5);
      track("book_toggle", { to: opening ? "open" : "close" });
      return;
    }
    case "openMonitor":
      s.setActiveSection("monitor");
      s.setActiveMonitorRoute(s.activeMonitorRoute ?? "#/projects");
      track("monitor_open");
      return;
    case "openProjects":
      s.setActiveSection("monitor");
      s.setActiveMonitorRoute("#/projects");
      track("projects_open");
      return;
    case "toggleTheme":
      s.setTheme(s.theme === "dark" ? "light" : "dark");
      track("theme_toggle", { to: s.theme === "dark" ? "light" : "dark" });
      return;
    case "focusCube":
      s.setActiveSection("cube");
      s.setFocusedObject("cube");
      track("cube_focus");
      return;
    case "togglePlantBlurb":
      s.togglePlantBlurb();
      track("plant_blurb_toggle");
      return;
    case "openContact":
      s.setActiveSection("monitor");
      s.setActiveMonitorRoute("#/contact");
      track("contact_open");
      return;
    case "toggleSpecs":
      s.toggleCpuBlurb();
      track("specs_toggle");
      return;
    case "toggleMug":
      s.toggleMugBlurb();
      track("mug_toggle");
      return;
    default:
      assertNever(action);
  }
};
